import React, { Component } from 'react';
import FetchData from '../../../Utils/FetchData';
import { connect } from 'react-redux'
import CollapseRightArea from './CollapseRightArea';
import ExpandRightArea from './ExpandRightArea';
import setTaskNameAction from '../../../../actions/setTaskNameAction'
import setTaskIdAction from '../../../../actions/setTaskIdAction'
import setFolderNameAction from '../../../../actions/setFolderNameAction'
import setFolderIdAction from '../../../../actions/setFolderIdAction'
import setNotificationsTasksAction from '../../../../actions/setNotificationsTasksAction'
import setFoldersNotificationsCountAction from '../../../../actions/setFoldersNotificationsCountAction'
import setActionTaskNotifications from '../../../../actions/setActionTaskNotifications'
import setContextsExpandCollapse from '../../../../actions/setContextsExpandCollapse'
import setActionTaskContextExpColaps from '../../../../actions/setActionTaskContextExpColaps'
import setActionDashboardlist from '../../../../actions/setActionDashboardlist';
import setActionTabs from '../../../../actions/setActionTabs';


import '../Task/task.css'


const $ = window.$;
function TriggeredKey(e) {
    var keycode;
    if (window.event) keycode = window.event.keyCode;
    if (window.event.keyCode != 13) return false;
}
//function searchingfor(term) {
  
//    return function (x) {
//        return x.name.toLowerCase().includes(term.toLowerCase()) || !term;
//    }
//}
var arrayNotificationsFolders = [];
var arrayNotificationsTasks = [];
var ar = [];
class Task extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Task: [],
           // term: '',
            searchtask: [],
        };
        //this.searchhandler = this.searchhandler.bind(this);
        if (this.props.roledataId !== undefined) {
            this.fetchTask()
        }


    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.Task != this.state.Task) {
            return true;
        }
        if (this.props.taskcontextExpandCollapse !== nextProps.taskcontextExpandCollapse) {
            return true
        }
        if (this.props.folderIdState !== nextProps.folderIdState) {
            arrayNotificationsFolders = [];
            arrayNotificationsTasks = [];
            return true
        }

        if (this.props.taskIdState != nextProps.taskIdState) {
            return true;
        }

        if (nextProps.roledataId != this.props.roledataId) {
            arrayNotificationsFolders = [];
            arrayNotificationsTasks = [];
            return true;
        }
        //if (nextState.term != this.state.term) {
        //    return true;
        //}

        if (nextProps.contextExpandCollapse != this.props.contextExpandCollapse) {
            return true
        }
        if (nextProps.notifications != this.props.notifications) {
            return true
        }
        if (nextProps.themeState != this.props.themeState) {
            return true
        }
        return false;
    }
    componentDidMount() {

        document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
    }

    componentDidUpdate(prevProps) {
        //this.props.actionTabsSet(true)
        //if (this.props.contextExpandCollapse === true) {

         
        //    if (prevProps.roledataId !== this.props.roledataId) {
        //        console.log('edo role id')
        //        document.getElementById('taskArea').style.marginTop = '-79px';
        //        document.getElementById('tasklabel').style.marginTop = '10px';
        //        document.getElementById('taskAreaCollapse').style.marginTop = '0px';
        //    }
        //    if (this.props.taskcontextExpandCollapse === false) {
               
        //        document.getElementById('taskAreaCollapse').style.visibility = 'visible';
        //        document.getElementById('taskArea').style.visibility = 'hidden';
              
        //    } else if (this.props.taskcontextExpandCollapse === true) {

        //        document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
        //        document.getElementById('taskArea').style.visibility = 'visible';
        //        document.getElementById('tasklabel').style.visibility = 'visible';
        //        document.getElementById('taskForm').style.visibility = 'visible';
        //        document.getElementById('taskTree').style.visibility = 'visible';
        //        document.getElementById('labelContext').style.visibility = 'hidden';
        //        document.getElementById('labelTask').style.visibility = 'hidden';
        //        document.getElementById('contextArea').style.marginTop = '0px';
        //    } else {
               
        //        document.getElementById('tasklabel').style.visibility = 'visible';
        //        document.getElementById('taskForm').style.visibility = 'visible';
        //        document.getElementById('taskTree').style.visibility = 'visible';
        //        document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
        //        document.getElementById('taskArea').style.visibility = 'visible';
        //        document.getElementById('labelTask').style.visibility = 'hidden';
        //        document.getElementById('labelContext').style.visibility = 'hidden';
        //    }
        //}

        //if (this.props.contextExpandCollapse === false) {
        //    console.log('contextExpandCollapseFALSE')
        //    if (this.props.taskcontextExpandCollapse === false) {
        //    }
        //    if (this.props.taskcontextExpandCollapse === true) {              
        //        var myElements = document.querySelectorAll(".contextResponsive");
        //        if (this.props.folderIdState === prevProps.folderIdState) {
        //            document.getElementById('taskAreaCollapse').style.marginTop = '0px';
        //            document.getElementById('taskArea').style.visibility = 'visible';
        //            document.getElementById('tasklabel').style.visibility = 'hidden';
        //            document.getElementById('taskForm').style.visibility = 'hidden';
        //            document.getElementById('taskTree').style.visibility = 'hidden';
        //            document.getElementById('taskArea').style.marginTop = '-79px';

        //        } else if (this.props.folderIdState !== prevProps.folderIdState) {
        //            this.props.contextExpandCollapseSet(true)
        //        }
        //        else {
                  
        //            document.getElementById('taskArea').style.visibility = 'visible';
        //            document.getElementById('tasklabel').style.visibility = 'visible';
        //            document.getElementById('taskForm').style.visibility = 'visible';
        //            document.getElementById('taskTree').style.visibility = 'visible';
        //            document.getElementById('labelTask').style.visibility = 'hidden';
        //            document.getElementById('labelContext').style.visibility = 'hidden';
        //            document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
        //        }
        //    }
        //}

        if (prevProps.roledataId != this.props.roledataId) {
            arrayNotificationsFolders = [];
            arrayNotificationsTasks = [];
            this.fetchTask()
        }
        if (prevProps.notificationsTasks != this.props.notificationsTasks) {
            this.fetchTask()
        }

        if (prevProps.notifications === undefined && this.props.notifications !== undefined) {
            this.fetchTask()

        }


    }

    //EditnavigateTaskSearch(e, id) {
    //    if (id != undefined) {


    //        var splitId = id.split(',')

    //        this.props.taskIdSet(splitId[0])
    //        this.props.taskNameSet(splitId[1])
    //    }
    //    this.setState({
    //        term: '',
    //    })
    //}
    //searchhandler(event) {
    //    this.setState({ term: event.target.value })
    //}
    //searchKeyPress(e) {
    //    if (e.key === "Enter") {
    //        e.preventDefault();
    //    }
    //}
    treeCount(obj) {
        if (Array.isArray(obj)) {
            for (var i = 0; i < obj.length; i++) {
                this.treeCount(obj[i]);
            }
        } else {
            if (this.props.notificationsTasks !== undefined) {
                var count = this.props.notificationsTasks.reduce(function (sum, record) {
                    if (record.taskId == obj.id) return sum + record.taskCount;
                    else return sum;
                }, 0);

                if (obj.items != undefined) {
                    for (var i = 0; i < obj.items.length; i++) {
                        count += this.treeCount(obj.items[i]);
                    }
                }
                // console.log(obj.id)
                //if (count > 0) {
                //    obj.name =  '<b style=color:blue>' + obj.name + '</b>'
                //} 

                obj.tags = count === 0 ? [] : [count];
                return count;
            }

        }
    }
    fetchTask = async () => {
     
        try {

            if (this.props.notifications !== undefined) {


                arrayNotificationsFolders = [];
                arrayNotificationsTasks = [];
                var notificationByrole = this.props.notifications.filter(item => item.roleID == this.props.roledataId)

                var uniqueFolderId = notificationByrole.map(item => item.folderID).filter((value, index, self) => self.indexOf(value) === index)
                var uniqueFolderId1 = notificationByrole.map(item => item.folderName).filter((value, index, self) => self.indexOf(value) === index)

                for (var value of uniqueFolderId) {
                    // console.log(' for (var value of uniqueFolderId)')
                    var not = notificationByrole.filter(item => item.folderID === value)

                    arrayNotificationsFolders.push({ folderId: value, folderCount: not.length })

                    var postparameters = {
                        userId: this.props.usedataState,
                        roleId: this.props.roledataId,
                        taskId: null,
                        folderId: value
                    };

                    var response = await FetchData('/api/RTFCW/URTFHelper/', 'POST', postparameters)

                    arrayNotificationsTasks.push({ taskId: response.data[0].taskId, taskCount: not.length, taskname: response.data[0].taskName })
                    this.props.currNotificationsTasksSet(arrayNotificationsTasks)
                    this.props.currNotificationsFoldersSet(arrayNotificationsFolders)
                }


                if (this.props.roledataId !== undefined) {

                    FetchData('/api/RTFCW/RoleTasksA/' + this.props.roledataId)

                        .then((data) => {

                            data.data.map((i) => {
                                i.name = i.name.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');

                            })
                            var byposition = data.data.slice(0)

                            byposition.sort(function (a, b) {
                                return a.PositionInBranch - b.PositionInBranch;
                            });
                            var nestTask = (items, id = 0, link = 'idparent') =>
                                items
                                    .filter(item => item[link] === id)
                                    .map(item => ({ ...item, items: nestTask(items, item.id) }));
                            nestTask(byposition);
                            let task = nestTask(byposition);

                            let removeEmpty = (task) => {
                                Object.keys(task).forEach(key =>
                                    (key === 'items' && task[key].length === 0) && delete task[key] ||
                                    (task[key] && typeof task[key] === 'object') && removeEmpty(task[key])
                                );
                                return task;
                            };
                            var taskwithNotify = removeEmpty(task)

                            this.treeCount(taskwithNotify)

                            this.setState({
                                Task: taskwithNotify,
                               // searchtask: data.data

                            })
                            if (this.props.taskIdState === undefined) {
                                this.props.taskNameSet(this.state.Task[0].name)
                                this.props.taskIdSet(this.state.Task[0].id)
                            }
                        })
                }
            } else {

                FetchData('/api/RTFCW/RoleTasksA/' + this.props.roledataId)
                    .then((data) => {

                        data.data.map((i) => {
                            i.name = i.name.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');

                        })
                        var byposition = data.data.slice(0);
                        byposition.sort(function (a, b) {
                            return a.PositionInBranch - b.PositionInBranch;
                        });
                        var nestTask = (items, id = 0, link = 'idparent') =>
                            items
                                .filter(item => item[link] === id)
                                .map(item => ({ ...item, items: nestTask(items, item.id) }));
                        nestTask(byposition);
                        let task = nestTask(byposition);
                        let removeEmpty = (task) => {
                            Object.keys(task).forEach(key =>
                                (key === 'items' && task[key].length === 0) && delete task[key] ||
                                (task[key] && typeof task[key] === 'object') && removeEmpty(task[key])
                            );
                            return task;
                        };
                        var taskwithNotify = removeEmpty(task)

                        this.treeCount(taskwithNotify)
                        this.setState({
                            Task: removeEmpty(task),
                           // searchtask: data.data
                        })
                        if (this.props.taskIdState === undefined) {
                            this.props.taskNameSet(this.state.Task[0].name)
                            this.props.taskIdSet(this.state.Task[0].id)
                        }
                    })
            }

        }

        catch (error) {
            console.error(error);
        }


    }
    //closesidebar = (ee2) => {

    //    this.props.actionDashboardlistset(undefined)
    //    document.getElementById('taskArea').style.visibility = 'hidden';
    //    document.getElementById('tasklabel').style.visibility = 'hidden';
    //    document.getElementById('taskForm').style.visibility = 'hidden';
    //    document.getElementById('taskTree').style.visibility = 'hidden';
    //    document.getElementById('taskAreaCollapse').style.visibility = 'visible';
    //    document.getElementById('taskAreaCollapse').style.marginTop = '24px';
    //    //document.getElementById('tasklabel').style.marginTop = '30px';
    //    document.getElementById('labelTask').style.visibility = 'visible';
    //    document.getElementById('labelContext').style.visibility = 'visible';
    //    document.getElementById('taskArea').style.marginTop = '-100px';
    //    this.props.actionTaskContextExpandCollapse(false)
    //    // return 
    //}
    //opensidebar = (ee) => {

    //    this.props.actionDashboardlistset(undefined)
    //    if (this.props.contextExpandCollapse === false) {

    //        document.getElementById('taskArea').style.visibility = 'hidden';
    //        document.getElementById('tasklabel').style.visibility = 'hidden';
    //        document.getElementById('taskForm').style.visibility = 'hidden';
    //        document.getElementById('taskTree').style.visibility = 'hidden';
    //        document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
    //        //document.getElementById('taskArea').style.visibility = 'visible';
    //        document.getElementById('tasklabel').style.marginTop = '10px';
    //        document.getElementById('labelTask').style.visibility = 'hidden';
    //        document.getElementById('labelContext').style.visibility = 'hidden';
    //        this.props.actionTaskContextExpandCollapse(true)
    //    } else {

    //        document.getElementById('tasklabel').style.visibility = 'visible';
    //        document.getElementById('taskForm').style.visibility = 'visible';
    //        document.getElementById('taskTree').style.visibility = 'visible';
    //        document.getElementById('taskAreaCollapse').style.visibility = 'hidden';
    //        document.getElementById('taskArea').style.visibility = 'visible';
    //        document.getElementById('taskArea').style.marginTop = '-100px';
    //        document.getElementById('tasklabel').style.marginTop = '10px';
    //        document.getElementById('labelTask').style.visibility = 'hidden';
    //        document.getElementById('labelContext').style.visibility = 'hidden';
    //        this.props.actionTaskContextExpandCollapse(true)
    //    }



    //}
    render() {

        var taskStyles;

        if (this.props.themeState === false || this.props.themeState === undefined) {

            taskStyles = window.defaultTheme;

        } else {

            taskStyles = window.darkTheme;

        }

        //(TM 29-01-19 ) Remove commas from task name
        this.state.searchtask.map((i) => {
            i.name = i.name.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');
        })

        var searchtask
        if (this.props.taskNameState != undefined) {
            searchtask = this.props.taskNameState.replace(/,/g, '').replace(/'/g, '').replace(/:/g, '').replace(/[()]/g, '');
        }

        var component = this;
       
        $(function () {
            //(TM 29-01-19 )Get tasks depending the role

            var $disabledTree = $('#treeview-task').treeview({

                //color: "#222",
                levels: 1,
                //nodeIcon: 'glyphicon glyphicon-file',
                showTags: true,

                data: component.state.Task,
                selectable: true,

                onNodeSelected: function (event, node) {

                    component.props.currTaskNotificationStateSet(node.tags)
                    component.props.taskNameSet(node.name)
                    component.props.taskIdSet(node.id)
                    component.props.folderNameSet(undefined)
                    component.props.folderIdSet(undefined)
                    component.props.actionTabsSet(undefined)

                },
            });

            var findDisabledNodes = function () {
                var div, li, a, i;


                var pattern = $('#input-disable-node').val();

                var options = {
                    ignoreCase: true,
                    exactMatch: true,
                    revealResults: true,
                };

                $disabledTree.treeview('search', [pattern, options]);
                div = document.getElementById("treeview-task");

                li = div.getElementsByTagName("li");

                for (i = 0; i < li.length; i++) {
                    a = li[i];

                    if (a.innerHTML.indexOf(pattern) > -1) {
                        if (a.innerHTML.indexOf(pattern) > 0) {
                            li[i].scrollIntoView(true);

                        }
                    }
                }
            };
            var disabledNodes = findDisabledNodes();
        });
        return (
            <div style={{ border: '0px solid #111' }}>

                
               
                {/*<div id="taskForm">
                        
                        <form style={{ width: '95%' }}>
                            <input
                                onKeyPress={this.searchKeyPress}
                                placeholder="Search..."
                                className="inputTask"
                                id="inputTask"
                                type="text"
                                onChange={this.searchhandler}
                                value={term}
                            />
                        </form>

                        <div style={style} >
                            <table>
                                {
                                    this.state.searchtask.filter(searchingfor(term)).map(task =>

                                        <tr id="searchTask" key={task.name} style={{ fontSize: '13px', marginTop: '2px', border: '0px', color: '#4D4D4D' }}>
                                            <td><i className="glyphicon glyphicon-chevron-right" style={{ cursor: 'Pointer', color: '#428bca', fontSize: '10px', top: '3px' }}></i><a className="tdFilter" style={{ marginLeft: '26px', marginTop: '-18px', cursor: 'Pointer' }} onClick={(e) => this.EditnavigateTaskSearch(e, task.id + "," + task.name)}>{task.name.replace("<b style=margin-right:69px>", "").replace("</b>", "")}</a></td>
                                        </tr>

                                    )
                                }
                            </table>
                        </div>
                    </div>*/}
                <div id="taskTree" >
                        <label className="sr-only" style={{ fontSize: '13px' }}>Search Tree:</label>
                        <input type="text" className="form-control" hidden id="input-disable-node" value={searchtask} />
                        <div style={taskStyles.rightFontstask} id="treeview-task"    ></div>

                    </div>
             
            </div>
        );
    }
}
//
const mapStateToProps = state => {
    return {
        folderIdState: state.folderDataId,
        roledataId: state.roleDataId,
        taskNameState: state.taskDataName,
        taskIdState: state.taskDataId,
        themeState: state.currentThemeName,
        notificationsTasks: state.currentNotificationsTasks,
        notifications: state.currNotifications,
        usedataState: state.userData,
        notificationsFolders: state.currentNotificationsFolders,
        contextExpandCollapse: state.currContextExpandCollapse,
        taskcontextExpandCollapse: state.currTaskContextExpandCollapse,
        folderNameState: state.folderDataName,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        taskNameSet: payload => dispatch(setTaskNameAction(payload)),
        taskIdSet: payload => dispatch(setTaskIdAction(payload)),
        folderNameSet: payload => dispatch(setFolderNameAction(payload)),
        folderIdSet: payload => dispatch(setFolderIdAction(payload)),
        currNotificationsTasksSet: payload => dispatch(setNotificationsTasksAction(payload)),
        currNotificationsFoldersSet: payload => dispatch(setFoldersNotificationsCountAction(payload)),
        currTaskNotificationStateSet: payload => dispatch(setActionTaskNotifications(payload)),
        actionTaskContextExpandCollapse: payload => dispatch(setActionTaskContextExpColaps(payload)),
        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        contextExpandCollapseSet: payload => dispatch(setContextsExpandCollapse(payload)),
        actionTabsSet: payload => dispatch(setActionTabs(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Task);





// WEBPACK FOOTER //
// ./src/components/TaskView/SideDraw/Task/Task.js